import { compact } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { SidePanelSettings, UserContext } from 'venn-components';
import { isReportState } from 'venn-state';
import { useHasFF, withSuspense } from 'venn-utils';
import { SidePanelRedesign } from '../../../../../venn-components/src/side-panel-settings/SidePanelSettingsRedesign';
import DropBlocksPanel from './panels/DropBlocksPanel';
import InputsPanel from './panels/InputsPanel';
import OutlinePanel from './panels/OutlinePanel';
import PagesPanel from './panels/PagesPanel';

const StudioMainLeftPanel = React.memo(function StudioMainLeftPanel() {
  const { hasPermission } = useContext(UserContext);
  const isReport = useRecoilValue(isReportState);
  const hasPortfolioFilering = useHasFF('block_assignment_ff');

  const studioInsertBlocksPermission = hasPermission('STUDIO_INSERT_BLOCKS');

  const sideBarItems = useMemo(
    () =>
      compact([
        {
          key: 'inputs',
          text: 'Inputs',
          Component: <InputsPanel />,
        },
        {
          key: 'outline',
          text: 'Outline',
          Component: isReport ? <PagesPanel /> : <OutlinePanel />,
        },
        studioInsertBlocksPermission && {
          key: 'insert',
          text: 'Insert',
          Component: <DropBlocksPanel />,
        },
      ]),
    [studioInsertBlocksPermission, isReport],
  );

  return hasPortfolioFilering ? (
    <SidePanelRedesign defaultKey="inputs" items={sideBarItems} />
  ) : (
    <SidePanelSettings defaultKey="inputs" items={sideBarItems} />
  );
});

export default withSuspense(null, StudioMainLeftPanel);
